import { ComputedPromotionStatus } from '../../../stores/types/promotions.interface';
import {
  PromoCodeAccessType,
  PromoCodeUsageLimitType,
} from '../../../stores/types/promoCode.interface';

// Length bounds surfaced to the user as live hints and enforced on save. The backend
// regex accepts 1–50 chars; 3–20 is the stricter product rule for the dashboard.
export const PROMO_CODE_MIN_LENGTH = 3;
export const PROMO_CODE_MAX_LENGTH = 20;

/**
 * Promo codes are created via a minimal form; access and usage limits are not yet
 * exposed in the UI, so new codes default to public and unlimited.
 */
export const DEFAULT_PROMO_CODE_ACCESS_TYPE = PromoCodeAccessType.PUBLIC;
export const DEFAULT_PROMO_CODE_USAGE_LIMIT_TYPE = PromoCodeUsageLimitType.UNLIMITED;

/** A promo code can only be added while the parent promotion is in one of these states. */
export const PROMO_CODE_ADDABLE_PROMOTION_STATUSES: ReadonlyArray<ComputedPromotionStatus> = [
  ComputedPromotionStatus.DRAFT,
  ComputedPromotionStatus.SCHEDULED,
  ComputedPromotionStatus.ACTIVE,
  ComputedPromotionStatus.PAUSED,
];
